import React from 'react';
import { stringSelectSpec } from '../../lib/editing-configs';
import PartnerPage from './lib/partner-page/partner-page';
import LayoutL1 from './lib/layout-l1/layout-l1';
import LayoutL2 from './lib/layout-l2/layout-l2';
import LayoutL2Banking from './lib/layout-l2-banking/layout-l2-banking';
import LayoutL2Investing from './lib/layout-l2-investing/layout-l2-investing';
import LayoutL2PersonalLoans from './lib/layout-l2-personal-loans/layout-l2-personal-loans';
import LayoutL2StudentLoans from './lib/layout-l2-student-loans/layout-l2-student-loans';
import LayoutL2Insurance from './lib/layout-l2-insurance/layout-l2-insurance';
import LayoutL2Mortgage from './lib/layout-l2-mortgage/layout-l2-mortgage';
import LayoutL2TravelRewards from './lib/layout-l2-travel-rewards/layout-l2-travel-rewards';

const layoutTypes = {
  DEFAULT: 'default',
  LAYOUT_L1: 'layout-l1',
  LAYOUT_L2: 'layout-l2',
  LAYOUT_L2_BANKING: 'layout-l2-banking',
  LAYOUT_L2_INVESTING: 'layout-l2-investing',
  LAYOUT_L2_PERSONAL_LOANS: 'layout-l2-personal-loans',
  LAYOUT_L2_STUDENT_LOANS: 'layout-l2-student-loans',
  LAYOUT_L2_INSURANCE: 'layout-l2-insurance',
  LAYOUT_L2_MORTGAGE: 'layout-l2-mortgage',
  LAYOUT_L2_TRAVEL_REWARDS: 'layout-l2-travel-rewards',
};

const AwardsHero2023 = ({
  subtitle,
  title,
  brandLogoUrl,
  brandLogoLink,
  topLeftIconUrl,
  bottomLeftIconUrl,
  topRightIconUrl,
  topLeftIconUrlMobile,
  // L1
  desktopLargeStarUrl,
  desktopSmallStarUrl,
  // L2
  desktopPromoImageUrl,
  mobilePromoImageUrl,
  largeStarUrl,
  mediumStarUrl,
  smallStarUrl,
  layout,
}) => {
  switch (layout) {
    case layoutTypes.LAYOUT_L1: {
      return (
        <LayoutL1
          subtitle={subtitle}
          title={title}
          brandLogoUrl={brandLogoUrl}
          brandLogoLink={brandLogoLink}
          topRightIconUrl={topRightIconUrl}
          desktopLargeStarUrl={desktopLargeStarUrl}
          desktopSmallStarUrl={desktopSmallStarUrl}
          bottomLeftIconUrl={bottomLeftIconUrl}
          topLeftIconUrlMobile={topLeftIconUrlMobile}
        />
      );
    }
    case layoutTypes.LAYOUT_L2: {
      return (
        <LayoutL2
          subtitle={subtitle}
          title={title}
          brandLogoUrl={brandLogoUrl}
          brandLogoLink={brandLogoLink}
          desktopPromoImageUrl={desktopPromoImageUrl}
          mobilePromoImageUrl={mobilePromoImageUrl}
          largeStarUrl={largeStarUrl}
          smallStarUrl={smallStarUrl}
        />
      );
    }
    case layoutTypes.LAYOUT_L2_BANKING: {
      return (
        <LayoutL2Banking
          subtitle={subtitle}
          title={title}
          brandLogoUrl={brandLogoUrl}
          brandLogoLink={brandLogoLink}
          desktopPromoImageUrl={desktopPromoImageUrl}
          mobilePromoImageUrl={mobilePromoImageUrl}
          largeStarUrl={largeStarUrl}
          smallStarUrl={smallStarUrl}
          mediumStarUrl={mediumStarUrl}
        />
      );
    }
    case layoutTypes.LAYOUT_L2_INVESTING: {
      return (
        <LayoutL2Investing
          subtitle={subtitle}
          title={title}
          brandLogoUrl={brandLogoUrl}
          brandLogoLink={brandLogoLink}
          desktopPromoImageUrl={desktopPromoImageUrl}
          mobilePromoImageUrl={mobilePromoImageUrl}
          largeStarUrl={largeStarUrl}
          smallStarUrl={smallStarUrl}
          mediumStarUrl={mediumStarUrl}
        />
      );
    }
    case layoutTypes.LAYOUT_L2_PERSONAL_LOANS: {
      return (
        <LayoutL2PersonalLoans
          subtitle={subtitle}
          title={title}
          brandLogoUrl={brandLogoUrl}
          brandLogoLink={brandLogoLink}
          desktopPromoImageUrl={desktopPromoImageUrl}
          mobilePromoImageUrl={mobilePromoImageUrl}
          largeStarUrl={largeStarUrl}
          smallStarUrl={smallStarUrl}
          mediumStarUrl={mediumStarUrl}
        />
      );
    }
    case layoutTypes.LAYOUT_L2_INSURANCE: {
      return (
        <LayoutL2Insurance
          subtitle={subtitle}
          title={title}
          brandLogoUrl={brandLogoUrl}
          brandLogoLink={brandLogoLink}
          desktopPromoImageUrl={desktopPromoImageUrl}
          mobilePromoImageUrl={mobilePromoImageUrl}
          largeStarUrl={largeStarUrl}
          smallStarUrl={smallStarUrl}
          mediumStarUrl={mediumStarUrl}
        />
      );
    }
    case layoutTypes.LAYOUT_L2_STUDENT_LOANS: {
      return (
        <LayoutL2StudentLoans
          subtitle={subtitle}
          title={title}
          brandLogoUrl={brandLogoUrl}
          brandLogoLink={brandLogoLink}
          desktopPromoImageUrl={desktopPromoImageUrl}
          mobilePromoImageUrl={mobilePromoImageUrl}
          largeStarUrl={largeStarUrl}
          smallStarUrl={smallStarUrl}
          mediumStarUrl={mediumStarUrl}
        />
      );
    }
    case layoutTypes.LAYOUT_L2_MORTGAGE: {
      return (
        <LayoutL2Mortgage
          subtitle={subtitle}
          title={title}
          brandLogoUrl={brandLogoUrl}
          brandLogoLink={brandLogoLink}
          desktopPromoImageUrl={desktopPromoImageUrl}
          mobilePromoImageUrl={mobilePromoImageUrl}
          largeStarUrl={largeStarUrl}
          smallStarUrl={smallStarUrl}
          mediumStarUrl={mediumStarUrl}
        />
      );
    }
    case layoutTypes.LAYOUT_L2_TRAVEL_REWARDS: {
      return (
        <LayoutL2TravelRewards
          subtitle={subtitle}
          title={title}
          brandLogoUrl={brandLogoUrl}
          brandLogoLink={brandLogoLink}
          desktopPromoImageUrl={desktopPromoImageUrl}
          mobilePromoImageUrl={mobilePromoImageUrl}
          largeStarUrl={largeStarUrl}
          smallStarUrl={smallStarUrl}
          mediumStarUrl={mediumStarUrl}
        />
      );
    }
    default:
      return (
        <PartnerPage
          subtitle={subtitle}
          title={title}
          brandLogoUrl={brandLogoUrl}
          brandLogoLink={brandLogoLink}
          topRightIconUrl={topRightIconUrl}
          topLeftIconUrl={topLeftIconUrl}
          bottomLeftIconUrl={bottomLeftIconUrl}
          topLeftIconUrlMobile={topLeftIconUrlMobile}
        />
      );
  }
};

AwardsHero2023.displayName = 'Awards Hero 2023';

AwardsHero2023.propTypes = {
  ...PartnerPage.propTypes,
};

AwardsHero2023.defaultProps = {
  layout: layoutTypes.DEFAULT,
};

AwardsHero2023.getEditingConfig = (componentDocument) => {
  const inputConfig = [];
  switch (componentDocument?.props?.layout) {
    case layoutTypes.DEFAULT:
      inputConfig.push(...PartnerPage.getEditingConfig());
      break;
    case layoutTypes.LAYOUT_L1:
      inputConfig.push(...LayoutL1.getEditingConfig());
      break;
    case layoutTypes.LAYOUT_L2:
      inputConfig.push(...LayoutL2.getEditingConfig());
      break;
    case layoutTypes.LAYOUT_L2_BANKING:
      inputConfig.push(...LayoutL2Banking.getEditingConfig());
      break;
    case layoutTypes.LAYOUT_L2_INVESTING:
      inputConfig.push(...LayoutL2Investing.getEditingConfig());
      break;
    case layoutTypes.LAYOUT_L2_PERSONAL_LOANS:
      inputConfig.push(...LayoutL2PersonalLoans.getEditingConfig());
      break;
    case layoutTypes.LAYOUT_L2_STUDENT_LOANS:
      inputConfig.push(...LayoutL2StudentLoans.getEditingConfig());
      break;
    case layoutTypes.LAYOUT_L2_INSURANCE:
      inputConfig.push(...LayoutL2Insurance.getEditingConfig());
      break;
    case layoutTypes.LAYOUT_L2_MORTGAGE:
      inputConfig.push(...LayoutL2Mortgage.getEditingConfig());
      break;
    case layoutTypes.LAYOUT_L2_TRAVEL_REWARDS:
      inputConfig.push(...LayoutL2TravelRewards.getEditingConfig());
      break;
    default:
      inputConfig.push(...PartnerPage.getEditingConfig());
  }
  return [
    ...inputConfig,
    stringSelectSpec('layout', 'Layout', [
      { label: 'Default', value: layoutTypes.DEFAULT },
      { label: 'Layout L1', value: layoutTypes.LAYOUT_L1 },
      { label: 'Layout L2', value: layoutTypes.LAYOUT_L2 },
      { label: 'Layout L2 Banking', value: layoutTypes.LAYOUT_L2_BANKING },
      { label: 'Layout L2 Investing', value: layoutTypes.LAYOUT_L2_INVESTING },
      {
        label: 'Layout L2 Personal Loans',
        value: layoutTypes.LAYOUT_L2_PERSONAL_LOANS,
      },
      {
        label: 'Layout L2 Student Loans',
        value: layoutTypes.LAYOUT_L2_STUDENT_LOANS,
      },
      { label: 'Layout L2 Insurance', value: layoutTypes.LAYOUT_L2_INSURANCE },
      { label: 'Layout L2 Mortgage', value: layoutTypes.LAYOUT_L2_MORTGAGE },
      {
        label: 'Layout L2 Travel Rewards ',
        value: layoutTypes.LAYOUT_L2_TRAVEL_REWARDS,
      },
    ]),
  ];
};

export default AwardsHero2023;
